import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Book, Mail } from 'lucide-react';
import AuthService from './AuthService';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import { Input } from '../components/Input';

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const response = await AuthService.forgotPassword(email);
      setMessage(response.message);
    } catch (err) {
      setError(err.response?.data?.error || 'An unexpected error occurred.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #faf5ff 0%, #fce7f3 50%, #dbeafe 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div style={{ width: '100%', maxWidth: '28rem' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <Link to="/login" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginBottom: '1rem', textDecoration: 'none' }}>
                <Book style={{ width: '2.5rem', height: '2.5rem', color: '#9333ea' }} />
                <span style={{ 
                  fontSize: '1.5rem',
                  fontWeight: '900',
                  fontFamily: '"Comic Sans MS", "Chalkboard SE", "Comic Neue", cursive, sans-serif',
                  display: 'flex', 
                  gap: '0.1rem',
                  letterSpacing: '0.05rem'
                }}>
                  <span style={{ 
                    color: '#ff4757',
                    WebkitTextStroke: '3px black',
                    paintOrder: 'stroke fill',
                    textShadow: '3px 3px 0px rgba(0,0,0,0.2)'
                  }}>R</span>
                  <span style={{ 
                    color: '#ff6b35',
                    WebkitTextStroke: '3px black',
                    paintOrder: 'stroke fill',
                    textShadow: '3px 3px 0px rgba(0,0,0,0.2)'
                  }}>e</span>
                  <span style={{ 
                    color: '#ffd93d',
                    WebkitTextStroke: '3px black',
                    paintOrder: 'stroke fill',
                    textShadow: '3px 3px 0px rgba(0,0,0,0.2)'
                  }}>a</span>
                  <span style={{ 
                    color: '#a855f7',
                    WebkitTextStroke: '3px black',
                    paintOrder: 'stroke fill',
                    textShadow: '3px 3px 0px rgba(0,0,0,0.2)'
                  }}>d</span>
                  <span style={{ 
                    color: '#ffd93d',
                    WebkitTextStroke: '3px black',
                    paintOrder: 'stroke fill',
                    textShadow: '3px 3px 0px rgba(0,0,0,0.2)'
                  }}>2</span>
                  <span style={{ 
                    color: '#06b6d4',
                    WebkitTextStroke: '3px black',
                    paintOrder: 'stroke fill',
                    textShadow: '3px 3px 0px rgba(0,0,0,0.2)'
                  }}>M</span>
                  <span style={{ 
                    color: '#3b82f6',
                    WebkitTextStroke: '3px black',
                    paintOrder: 'stroke fill',
                    textShadow: '3px 3px 0px rgba(0,0,0,0.2)'
                  }}>e</span>
                </span>
            </Link>
            <h1 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '0.5rem' }}>Forgot Your Password?</h1>
            <p style={{ color: '#6b7280', fontSize: '1rem' }}>No problem. Enter your email and we'll send a reset link.</p>
        </div>

        <Card style={{ padding: '2rem' }}>
          {message ? (
             <div style={{ padding: '0.75rem', background: '#dcfce7', color: '#166534', borderRadius: '0.5rem', marginBottom: '1rem', fontSize: '0.875rem' }}>
               {message}
             </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              {error && <div style={{ padding: '0.75rem', background: '#fee2e2', color: '#991b1b', borderRadius: '0.5rem', fontSize: '0.875rem' }}>{error}</div>}
              
              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151', fontSize: '0.875rem' }}>Email</label>
                <Input 
                  icon={Mail}
                  type="email" 
                  placeholder="your.email@example.com" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <Button type="submit" variant="primary" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
                {loading ? 'Sending...' : 'Send Reset Link'}
              </Button>
            </form>
          )}

          <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
            <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
              Remember your password?{' '}
              <Link to="/login" style={{ color: '#9333ea', fontWeight: '600' }}>
                Sign In
              </Link>
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
};